import "react-toastify/dist/ReactToastify.css";

export const FireBaseNotification = () => {};

export const CustomToast = ({ title, body }) => (
  <div>
    <strong>{title}</strong>
    {/* <div>{body}</div> */}
  </div>
);
